const changeTemplate = function (div) {
  const newDiv = document.getElementById(div + "-new").text;
  const oldDiv = document.getElementById(div);
  oldDiv.text = newDiv;
};

const changeTemplateMobile = function (div) {
  const newDiv = document.getElementById(div + "-new-mobile").text;
  const oldDiv = document.getElementById(div);
  oldDiv.text = newDiv;
}; 
 
$("body").on(
  "click",
  ".wizzy-search-filters-left-wrapper-apply-button",
  function (event) {
    let filterBg = document.querySelector(".wizzy-filters-bg");
    if (filterBg) {
      filterBg.click();
    }
  }
);

function collectionToHideSoldOut(handle) {
  const collectionHandle = [
    "true-wireless-bluetooth-earbuds-with-mic",
    "boult-mustang",
    "over-ear-bluetooth-headphone-with-mic",
    "smart-watches",
    "paydaysale",
    "summer-sale"
  ];
  return collectionHandle.includes(handle);
}

window.onWizzyScriptLoaded = function () {
  const inputFields = document.querySelectorAll("#Search-In-Modal");
  inputFields.forEach((inputField) => {
    inputField.addEventListener("input", () => {
      setTimeout(() => {
        const viewMoreButton = document.querySelector(
          ".autocomplete-top-products-view-more"
        );
        if (inputField.value.length === 0 && viewMoreButton) {
          // viewMoreButton.classList.add("wizzy-display-none");
          viewMoreButton.style.display = "none";
        } else if (viewMoreButton) {
          // viewMoreButton.classList.add("wizzy-display-block");
          viewMoreButton.style.display = "block";
        }
      }, 1000);
    });
  });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutationRecord) {
      const headerEle = mutationRecord.target;
      if (headerEle.classList.contains("search-modal-open")) {
        setTimeout(function () {
          $(".header #Search-In-Modal").click();
        }, 200);
      }
    });
  });

  var target = document.querySelector("header");
  observer.observe(target, { attributes: true, attributeFilter: ["class"] });

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      // console.log(data, "<===BEFORE_INIT");

      data.search.configs.facets.leftFacets.firstLeftDefaultOpened = false;
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      data.search.configs.facets.leftFacets.mobileCollapsible = true;

      let facetsLength =
        window.wizzyConfig.search.configs.facets.configs.length;
      let facets = window.wizzyConfig.search.configs.facets.configs;
      for (let i = 0; i < facetsLength; i++) {
        if (facets[i].key === "colors") {
          facets[i].key = "product_value_tags_color";
        }
      }

      wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
        dom: "header search-form #Search-In-Modal",
        type: "search",
      };

      if (document.documentElement.clientWidth < 768) {
        wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          dom: "header .search__input",
          type: "search",
        };
      }

      data.search.configs.general.minQueryLength = 1;
      window.wizzyConfig["search"]["configs"]["pagination"][
        "infiniteScrollOffset"
      ] = {
        desktop: 7000,
        mobile: 7000,
      };
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (payload) {
      // document.querySelector("body").addClass("wizzy-search-results-rendered");
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {
      console.log(payload, "<===BEFORE_FILTERS_EXECUTED");
      // payload.filters.getAllVariants = "true";
      // if (
      //   window.wizzyConfig.common.isOnCategoryPage &&
      //   collectionToHideSoldOut(window.wizzyConfig.common.collectionHandle)
      // ) {
      //   payload.filters.inStock = ["true"];
      // }
      if (window.wizzyConfig.common.isOnCategoryPage) {
        filters = payload["filters"];
        if (typeof filters === "object") {
          filters.sort = setDefaultSorts(filters.sort);
          if (filters.sort.length < 2)
            filters.sort = filters.sort.concat(getOrderSorts());
          payload["filters"] = filters;
        }
        payload = replaceDefaultSortOrder(payload);
      }
      // payload.filters.showOOSProductsInOrder = "true";
      payload.filters.inStock = [true, false];

      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      if (window.wizzyConfig.common.isOnCategoryPage) {
        payload.sort = setDefaultSorts(payload.sort);
        if (filters.sort.length < 2)
          payload.sort = payload.sort.concat(getOrderSorts());
      }
                  const wizzy_back_button = document.querySelector(".wizzy-search-back");
      if(wizzy_back_button){
      wizzy_back_button.click();
      }
      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      if (window.wizzyConfig.common.isOnCategoryPage) {
        payload.sort = setDefaultSorts(payload.sort);
        if (filters.sort.length < 2)
          payload.sort = payload.sort.concat(getOrderSorts());
      }
      return payload;
    }
  );
  function replaceDefaultSortOrder(payload) {
    let inputString = window.wizzyCollectionsSortOrderConfig;
    if (
      !isValidJsonString(inputString) ||
      typeof payload.filters?.sort === "undefined"
    ) {
      return payload;
    }
    let collectionDefaultSortOrders = JSON.parse(inputString);
    let currentCollection = window.wizzyConfig.common.categoryUrlKey;
    for (const [key, value] of Object.entries(collectionDefaultSortOrders)) {
      if (key === currentCollection) {
        let newSortOrder = payload.filters.sort.filter(function (item) {
          return !(
            item["field"] === value["field"] && item["order"] === value["order"]
          );
        });
        newSortOrder.unshift({
          field: value["field"],
          order: value["order"],
        });
        payload.filters.sort = newSortOrder;
      }
    }
    return payload;
  }
  function isValidJsonString(input) {
    try {
      const result = JSON.parse(input);
      return Array.isArray(result) || typeof result === "object";
    } catch (error) {
      return false;
    }
  }
  function getOrderSorts() {
    var sortOrderField =
      "product_" +
      window.wizzyConfig.common.collectionHandle +
      "_sortOrder:float";
    var sortOrder = "asc";
    if (window.wizzyConfig.common.collectionDefaultSort === "best-selling") {
      sortOrderField = "product_wizzy-best-selling_sortOrder:float";
      sortOrder = "asc";
    }
    if (window.wizzyConfig.common.collectionDefaultSort === "title-ascending") {
      sortOrderField = "name";
      sortOrder = "asc";
    }
    if (
      window.wizzyConfig.common.collectionDefaultSort === "title-descending"
    ) {
      sortOrderField = "name";
      sortOrder = "desc";
    }
    if (window.wizzyConfig.common.collectionDefaultSort === "price-ascending") {
      sortOrderField = "sellingPrice";
      sortOrder = "asc";
    }
    if (
      window.wizzyConfig.common.collectionDefaultSort === "price-descending"
    ) {
      sortOrderField = "sellingPrice";
      sortOrder = "desc";
    }
    if (
      window.wizzyConfig.common.collectionDefaultSort === "created-ascending"
    ) {
      sortOrderField = "createdAt";
      sortOrder = "asc";
    }
    if (
      window.wizzyConfig.common.collectionDefaultSort === "created-descending"
    ) {
      sortOrderField = "createdAt";
      sortOrder = "desc";
    }
    return [
      {
        field: sortOrderField,
        order: sortOrder,
      },
    ];
  }
  function setDefaultSorts(sort) {
    if (!Array.isArray(sort) || (Array.isArray(sort) && sort.length === 0)) {
      sort = [
        {
          field: "relevance",
          order: "asc",
        },
      ];
    }
    return sort;
  }
  updateWizzyConfig();

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {
      // console.log(data, "<===BEFORE_AUTOCOMPLETE_EXECUTED");
      // data.showOOSProductsInOrder = "true";
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers[0] = "main";
      let x = document.querySelector(".collection-hero--with-image");
      let y = document.querySelector(".collection-head");
      if (typeof x !== "undefined" && x !== null) {
        x.style.display = "none";
      }
      if (typeof y !== "undefined" && y !== null) {
        y.style.display = "none";
      }

      // data.showOOSProductsInOrder = "true";

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      if (
        !window.wizzyConfig.common.isOnCategoryPage &&
        typeof data.filters !== "undefined"
      ) {
      }

      // console.log(data, "<===BEFORE_FILTERS_EXECUTED");
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,

    function (data) {
        console.log("wizzy after product before function"); 

        data.forEach(product => {
            (product.attributes || []).forEach(attr => {
                if (attr.id === "product_balance_amount_custom") {
                    product.balanceAmountText = attr.name;
                    product.balanceAmountValue = attr.values[0].value[0];

                    console.log(
                        "Balance Amount Text:",
                        product.balanceAmountText
                    );

                    console.log(
                        "Balance Amount Value:",
                        product.balanceAmountValue
                    );
                }
            });
        });

      const isMobile =
        document.documentElement.clientWidth < 768 ? true : false;
      let n = data.length;
      let m = 0;
      for (let i = 0; i < n; i++) {
        data[i]["hideRatting"] = false;
        if (data[i]["sellingPrice"]) {
          data[i]["sellingPrice"] = getModifiedAmount(data[i]["sellingPrice"]);
        }
        if (data[i]["price"]) {
          data[i]["price"] = getModifiedAmount(data[i]["price"]);
        }

        m = data[i].attributes.length;
        for (let j = 0; j < m; j++) {
          if (data[i].attributes[j].id === "product_clp_desktop_image_boult") {
            data[i].mainImage = data[i].attributes[j].values[0].value[0];
          }
          if (data[i].attributes[j].id === "product_clp_video_custom") {
            data[i].clpVideoUrl = data[i].attributes[j].values[0].value[0];
          }
          if (data[i].attributes[j].id === "product_tags") {
            const tags =
              data[i]?.attributes[j]?.values?.[0]?.value[0];

            if (typeof tags === 'string') {
              const tag_values = tags.split(',').map(v => v.trim());

              //  console.log(tag_values);

              if (tag_values.includes('excludes-prepaid50')) {
                data[i].exclude50 = true;

                
              }
            }
          }

          if (data[i].attributes[j].id === "product_badge_judgeme") {
            let htmlCode = data[i].attributes[j].values[0].value[0];
            const tempElement = document.createElement("div");
            tempElement.innerHTML = htmlCode;

            const badgeElement = tempElement.querySelector(
              ".jdgm-prev-badge[data-average-rating]"
            );
            const averageRating = badgeElement.getAttribute(
              "data-average-rating"
            );

            data[i]["avgRatings"] = parseFloat(averageRating).toFixed(1);
            data[i]["hideRatting"] =
              data[i]["avgRatings"] == 0 || data[i]["avgRatings"] == 0.0
                ? true
                : false;
          }
          if (data[i].attributes[j].id === "product_product_tags_boult") {
            data[i].hasCustomTag = true;
            data[i].customTagValue = data[i].attributes[j].values[0].value[0];
          } else if (
            data[i].attributes[j].id === "product_clp_product_description_boult"
          ) {
            data[i].customDescription =
              data[i].attributes[j].values[0].value[0];
          } else if (data[i].attributes[j].id === "product_handle") {
            data[i].productHandle = data[i].attributes[j].values[0].value[0];
          }else if (data[i].attributes[j].id === "product_productusp_custom") {
            data[i].productUSP = data[i].attributes[j].values[0].value[0];
          }
          // else if(data[i].attributes[j].id === "product_clp_desktop_image_boult" && !isMobile) {
          //   data[i].mainImage = data[i].attributes[j].values[0].value[0];
          // }else if(data[i].attributes[j].id === "product_clp_mobile_images_boult" && isMobile) {
          //   data[i].mainImage = data[i].attributes[j].values[0].value[0];
          // }
        }
      }

      // Swatches setup
      for (let i = 0; i < n; i++) {
        if (
          typeof data[i].swatches !== "undefined" &&
          data[i].swatches.length == 1
        ) {
          m = data[i].swatches[0].values.length;
          if (m > 3) {
            data[i].remainingSwatch = m - 3;
          }
          while (m > 3) {
            data[i].swatches[0].values.pop();
            m--;
          }
          for (let j = 0; j < m; j++) {
            data[i].swatches[0].values[j].colorHashCode =
              typeof colorHashMap.get(data[i].swatches[0].values[j].value) ===
              "undefined"
                ? data[i].swatches[0].values[j].value
                : colorHashMap.get(data[i].swatches[0].values[j].value);

            if (typeof data[i].productHandle !== "undefined") {
              data[i].swatches[0].values[j].swatchURL =
                "https://www.boultaudio.com/products/" +
                data[i].productHandle +
                "?variant=" +
                data[i].swatches[0].values[j].variationId;
            }
          }
        }
      }

      data.forEach(product => {
        if (
          product.groupId &&
          (product.groupId == "8197476679749" ||
          product.groupId == "8197278793797"  || product.groupId == "8230376800325"
          || product.groupId == "8230406029381" || product.groupId == "8230411862085" || product.groupId == "8252613623877" || product.groupId == "8252613263429" || product.groupId == "8267349033029") 
        ) {
          // console.log("I got here");
          product.preBook = true;
        }
        if (
          product.groupId &&
          (product.groupId == "8230376800325"
          || product.groupId == "8230406029381" || product.groupId == "8230411862085") 
        ) {
          // console.log("I got here");
          product.balance  = true;
        }
      });

      data.forEach(product => {
        if (product.attributes && Array.isArray(product.attributes)) {
          product.attributes.forEach(attr => {
            // Product Tags
            if (
              attr.id === "product_tags" &&
              attr.values?.length
            ) {
              const tags = attr.values[0]?.value || [];
              const normalizedTags = Array.isArray(tags) ? tags.flatMap(tag => tag.split(",").map(t => t.trim())) : [];
              // console.log(normalizedTags, normalizedTags.includes("pre-order"), "wiz tags");
              product.preBook = normalizedTags.includes("pre-order");
            }
          });
        }
      });

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (data) {
      var facets = data.response.payload.facets;
      facets.forEach((facet) => {
        if (facet.key === "product_value_tags_color") {
          const facetItem = facet.data;
          console.log(facetItem, "<===");
          facetItem.forEach((item) => {
            item.isSwatch = true;
            item.isVisualSwatch = true;
            item.swatchValue =
              typeof colorHashMap.get(item.key) === "undefined"
                ? item.key
                : colorHashMap.get(item.key);
            item.isURLSwatch = false;
            item.data = {
              value:
                typeof colorHashMap.get(item.key) === "undefined"
                  ? item.key
                  : colorHashMap.get(item.key),
              swatch: {
                type: "visual",
                value:
                  typeof colorHashMap.get(item.key) === "undefined"
                    ? item.key
                    : colorHashMap.get(item.key),
              },
            };
          });
        }
      });
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (data) {
      var summaryHeading = document.querySelector(".wizzy-summary-head");
      if (!summaryHeading || !summaryHeading.textContent.trim()) {
        var pageStore = window.wizzyConfig && window.wizzyConfig.pageStore;
        var searchedQuery = new URLSearchParams(window.location.search).get("q")
          || (pageStore && pageStore.searchInputValue)
          || "";
        if (typeof searchedQuery !== "string") {
          searchedQuery = "";
        }
        searchedQuery = searchedQuery.trim();

        var resultTotal = pageStore && pageStore.searchedResponse && pageStore.searchedResponse.total;
        var isSearchPage = window.location.pathname.indexOf("/search") !== -1 || searchedQuery.length > 0;

        if (isSearchPage && (resultTotal || searchedQuery)) {
          var fillSummaryHeading = function (heading) {
            heading.textContent = "";
            var lead = resultTotal ? resultTotal + " Results found" : "Results found";
            if (searchedQuery) {
              heading.appendChild(document.createTextNode(lead + " for "));
              var queryText = document.createElement("strong");
              queryText.textContent = "\"" + searchedQuery + "\"";
              heading.appendChild(queryText);
              heading.appendChild(document.createTextNode(":"));
            } else {
              heading.textContent = lead;
            }
          };

          if (summaryHeading) {
            fillSummaryHeading(summaryHeading);
          } else {
            var summaryWrapper = document.querySelector(".wizzy-search-summary-wrapper");
            if (!summaryWrapper) {
              var resultsWrapper = document.querySelector(".wizzy-search-results-wrapper");
              if (resultsWrapper && resultsWrapper.parentNode) {
                summaryWrapper = document.createElement("div");
                summaryWrapper.className = "wizzy-search-summary-wrapper";
                resultsWrapper.parentNode.insertBefore(summaryWrapper, resultsWrapper);
              }
            }

            if (summaryWrapper) {
              var summaryContainer = document.createElement("div");
              summaryContainer.className = "wizzy-search-summary-container";
              summaryHeading = document.createElement("p");
              summaryHeading.className = "wizzy-summary-head";
              fillSummaryHeading(summaryHeading);
              summaryContainer.appendChild(summaryHeading);
              summaryWrapper.appendChild(summaryContainer);
            }
          }
        }
      }

      const currentURL = window.location.href;
      if (
        currentURL.includes("/collections/workout") ||
        currentURL.includes("/collections/travel") ||
        currentURL.includes("/collections/work") ||
        currentURL.includes("/collections/entertainment") ||
        currentURL.includes("/collections/audiophile")
      ) {
        let x = document.querySelector(
          '[data-key="product_value_tags_activity"]'
        );
        let categoryFacet = document.querySelector(
          '[data-key="product_value_tags_category"]'
        );
        if (categoryFacet) {
          categoryFacet.style.display = "block";
        }

        if (x) {
          x.style.display = "none";
        }
      }
      $("#search-btn").click(function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        $("header").addClass("search-modal-open");
        $(".popup-cat").removeClass("dialog-open");
        $(".search__input.field__input").focus();
      });
      $("#pop-explore-btn").click(function () {
        $(".popup-cat").addClass("dialog-open");
        $("header").removeClass("search-modal-open");
      });
      $("#close-dialog-btn").click(function () {
        $(".popup-cat").removeClass("dialog-open");
      });

      if (window.location.href.includes("/collections/straps")) {
        let x = document.querySelector(
          '[data-key="product_value_tags_straps"].wizzy-filters-facet-block'
        );
        if (x) x.style.display = "block";
      }

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      let sortByLabel = document.querySelector(".wizzy-common-select-label");
      if (sortByLabel) {
        sortByLabel.innerHTML = "Sort";
      }
      return data;
    }
  );

  $("body").on("click", ".bottom-bar .search-icon", function (event) {
    event.preventDefault();
    $(".header__search .icon-search").click();
  });

  changeTemplate("wizzy-search-results-product");
  changeTemplate("wizzy-search-results");
  if (document.documentElement.clientWidth > 768) {
    changeTemplate("wizzy-autocomplete-topproducts");
    changeTemplate("wizzy-search-wrapper");
  }
  if (document.documentElement.clientWidth < 768) {
    changeTemplateMobile("wizzy-search-wrapper");
  }
  setTimeout(() => {
    const targetNode = document.querySelector('.wizzy-body-end-wrapper');

function updateBodyClass() {
  const autocompleteElement = targetNode.querySelector('.wizzy-autocomplete-wrapper');
  if (
    autocompleteElement &&
    window.getComputedStyle(autocompleteElement).display === 'flex'
  ) {
    document.body.classList.add('wizzy-autocomplete-open');
    document.getElementsByTagName('html')[0].classList.add('wizzy-autocomplete-open');
  } else {
    document.body.classList.remove('wizzy-autocomplete-open');
    document.getElementsByTagName('html')[0].classList.remove('wizzy-autocomplete-open');
  }
}

const wizzy_observer_config = { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] };
const callback = function (mutationsList, observer) {
  for (const mutation of mutationsList) {
    updateBodyClass();
    break; // One update is enough per mutation batch
  }
};

const observer = new MutationObserver(callback);
if (targetNode) {
  observer.observe(targetNode, wizzy_observer_config);
  updateBodyClass();
}
}, 1000);
};

const collectionBackgroundMapper = {
  "ganesh-chaturthi": "rakhi-bisque",
};

function getBackgroundColor() {
  let pathName = window.location.pathname;
  let collectionName = pathName.split("/collections/");
  collectionName = collectionName[1];
  const color = collectionBackgroundMapper[collectionName]
    ? collectionBackgroundMapper[collectionName]
    : false;
  console.log("color", color);
  if (color) {
    document.getElementById("MainContent").classList.add("rakhi-bisque");
    document
      .getElementById("wizzy-shopify-collection-page-wrapper")
      .classList.add("rakhi-bisque");
  }
}

getBackgroundColor();

function getModifiedAmount(data) {
  return data.replace(".00", "");
}

const colorHashMap = new Map([
  ["Rose Gold", "#F19898"],
  ["Grey Green", "#9C9893"],
  ["Tan Brown", "#B65F26"],
  ["Emerald", "#315353"],
  ["Icon", "#757059"],
  ["Regal", "#273E4D"],
  ["Rig", "#1D253A"],
  ["Flip", "#393C2B"],
  ["Switch", "#906E61"],
  ["Pista Green", "#a5ac71"],
  ["Tan Brown", "#B65F26"],
  ["Blue", "blue"],
  ["Light Blue", "#ADD8E6"],
  ["Coffee", "#6F4E37"],
  ["Cream", "#EBE4DB"],
  ["Blue Moss", "#cdd331"],
  ["Candy Cane", "#de9596"],
  ["Sand Black", "#464646"],
  ["white", "white"],
  ["Black", "black"],
  ["Green", "green"],
  ["Grey", "grey"],
  ["Dark Blue", "#0000FF"],
  ["Pink", "#ffc0cb"],
  ["yellow", "#FFFF00"],
  ["brown", "brown"],
  ["silver", "#dedcdb"],
  ["red", "red"],
  ["LightBlue", "#add8e6"],
  ["Spring Green", "#d1c7b1"],
  ["Powder Blue", "#cedbe0"],
  ["Flamingo Pink", "#e8b2ab"],
  ["Raven Black", "black"],
  ["Emerald", "#324b4c"],
  ["Khaki Green", "#a4946c"],
  ["Ivory White", "#dcdedd"],
  ["Silver Metal", "#c3bdb8"],
  ["Bullet Silver", "#aca9a3"],
  ["Silicone Black", "#161616"],
  ["Coal Black", "#0d0d0d"],
  ["Denim Blue", "#305475"],
  ["Berry Red", "#8d0115"],
  ["Black Gloss", "#110011"],
  ["White Opal", "#e7e2dd"],
  ["Smoky Metal", "#aaa9ad"],
  ["Glacier Blue", "#badbe2"],
  ["Pine Green", "green"],
  ["Blue Lustre", "#112b47"],
  ["Ash Black", "black"],
  ["Grape Purple", "#6b161f"],
  ["Smoky White", "#ebe8e0"],
  ["Black", "#000"],
  ["Cobalt Blue", "#18376a"],
  ["Midnight", "#0f0f0f"],
  ["Dawn", "#d3cdc6"],
  ["Jungle", "#505c52"],
  ["Lavender", "#acb7cc"],
  ["Sliver Sand", "#a5a0a2"],
  ["Ruby Bronze", "#882a30"],
  ["Midnight Marine", "#171e38"],
  ["Scarlet Ebony", "#090a07"],
  ["Nautical Black", "#090a07"],
  ["White Wave", "#b6b6b6"],
  ["Beach Rose", "#6c6c6c"],
  ["Space Black", "black"],
  ["Orange", "orange"],
  ["Silver Sand", "grey"],
  ["Jet Black", "black"],
  ["Amber Blue", "blue"],
  ["Black Coffee", "#6F4E37"],
  ["Black Leather", "#253529"],
  ["Black Silicone", "#414a4c"],
  ["Carbon Copper", "#B87333"],
  ["Icy Blue", "#dcf3ff"],
  ["Inox steel", "#CFD4D9"],
  ["Pure Black", "#000"],
]);

    if (window.innerWidth <= 768) {
    const front_input = document.querySelector("#WI_search_btn");

    front_input && front_input.addEventListener("click", function (e) {
      e.preventDefault();
      const back_input = document.querySelector("#search_mini_form input");
      back_input && back_input.click();
      let search_form = document.querySelector("#search_mini_form");
      search_form && (search_form.style.display = "block",
        setTimeout(() => {
          let search_bar = search_form.querySelector("input");
          search_bar && search_bar.click()
        }
          , 300));
    });
  }
 